export const PAGE = 'editAlarmPage';
export const FORM = 'editAlarmForm';
export const TABLE = 'alarmActivityTable';
export const USERS_OMNI = 'usersOmni';
export const SET_PAGE_DATA = `app/${PAGE}/SET_PAGE_DATA`;
export const FILTER_ORG_USERS = `app/${PAGE}/FILTER_ORG_USERS`;
export const REQUEST_ALARM_ACTION = `app/${PAGE}/REQUEST_ALARM_ACTION`;
